import type {UseQueryOptions, UseQueryResult} from '@tanstack/react-query'
import {useAsync} from '@freckle/educator-entities/ts/common/hooks/use-async'
import type {CourseMembershipAttrs} from '@freckle/educator-entities/ts/roster/models/course-membership'
import {fetchCourseMemberships} from '@freckle/educator-entities/ts/roster/models/course-membership'

export const QUERY_KEY = 'fetchCourseMemberships'

export function useCourseMemberships(
  options?: Partial<UseQueryOptions<CourseMembershipAttrs[]>>,
): UseQueryResult<CourseMembershipAttrs[]> {
  const defaultOptions = {staleTime: 60 * 1000}
  return useAsync(fetchCourseMemberships, QUERY_KEY, [], {
    ...defaultOptions,
    ...options,
  })
}
